<template>

  <div class="map-wrapper" >
      <l-map
        id="mapdiv"
        :zoom="zoom"
        :center="initLocation"
        :options="mapOptions"
        :noBlockingAnimations="noBlocking"
        ref="greenMap"
      >
        <l-tile-layer
          :url="terrain"
          :attribution="attribution"
          :tms="true"
        />
        <l-tile-layer
          v-if="showGreenleaf"
          :url="greenleaf"
          :attribution="attribution"
          :tms="true"
        />
        <l-geo-json
            :geojson="geojson"
            :options="geoOptions"
        />
      </l-map>
    <div class="map-layers-controls">
      <div class="layers">
        <h3>Map Layers</h3>
        <!-- toggle greeleaf  -->
        <p>
          <input
            type="radio"
            id="one"
            v-model="showGreenleaf"
            v-bind:value="true"
          />
          <label for="one">1820 Journey</label>
        </p>
        <p>
          <input
            type="radio"
            id="two"
            v-model="showGreenleaf"
            v-bind:value="false"
          />
          <label for="two">Present Day</label>
        </p>
        <!-- <p>
          <input
            type="checkbox"
            id="three"
          />
          <label for="two">Roads &amp; Towns</label>
        </p> -->

      </div>
      <!-- custom zoom -->
      <h3>Map Zoom</h3>
      <span @click="customZoom(-0.5)">
        <img :src="'images/markers/zoom-out.jpg'">
      </span>
      <span @click="customZoom(0.5)">
        <img :src="'images/markers/zoom-in.jpg'">
      </span>
    </div> <!-- map layers controls -->
  </div> <!-- map wrapper -->
</template>

<script>
import { LMap, LTileLayer, LGeoJson } from 'vue2-leaflet'
// import { latLng, icon, Point } from 'leaflet'
import L from 'leaflet'
import { eventBus } from '../main'

export default {
  name: 'TreatMap',
  components: {
    LMap,
    LTileLayer,
    LGeoJson
  },
  props: {
    entry: {
      type: Object
    },
    entries: {
      type: Array
    },
    reSetEntry: {
      type: Function
    },
    currIndex: Number
  },
  data () {
    return {
      zoom: 9,
      noBlocking: false,
      offset: 400,
      zoomOffset: 0.5,
      // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      initLocation: L.latLng(46.25, -68.8), // hard-wired to match data
      mapOptions: {
        zoomSnap: 0.25,
        zoomControl: false,
        touchZoom: true,
        dragging: true,
        tap: false,
        minZoom: 8,
        maxZoom: 11,
        maxBounds: [
          [43, -74], // southWest
          [48, -66] // northEast
        ]
      },
      showGreenleaf: true,
      testMarker: null,
      prevSelected: 0,
      markerList: [null],
      geojson: {
        type: 'FeatureCollection',
        name: 'TreatPat-4326',
        crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
        features: [
          { type: 'Feature', properties: { LENGTH: '126.66 km', SINUOSITY: '1.3414262' }, geometry: { type: 'LineString', coordinates: [[-68.769610267361656, 44.793960035681863], [-68.740690752468439, 44.807811325137095], [-68.704935715873205, 44.821285042068929], [-68.695471147362682, 44.826523964963108], [-68.697574384809471, 44.833633165096515], [-68.701255050341331, 44.839619175218139], [-68.700203431617936, 44.857573449373795], [-68.694419528639301, 44.863556955359456], [-68.683903341405397, 44.870661555610482], [-68.668129060554563, 44.874400464313119], [-68.658138682682349, 44.882625202669161], [-68.645519258001684, 44.891596294640308], [-68.640261164384739, 44.907292316250086], [-68.635528880129485, 44.923731140764573], [-68.637106308214584, 44.936057152287127], [-68.639209545661345, 44.949874059054231], [-68.638683736299654, 44.959581234031361], [-68.638683736299654, 44.976004995079677], [-68.639209545661345, 44.985707719534602], [-68.653406398427109, 45.002590249970908], [-68.662870966937604, 45.018255742563944], [-68.667603251192872, 45.05525765326967], [-68.668654869916253, 45.082178403650651], [-68.664974204384393, 45.091490569731228], [-68.660767729490829, 45.098939202259849], [-68.647096686086769, 45.112809673098873], [-68.640261164384739, 45.119883237497206], [-68.63027078651254, 45.128817004514694], [-68.63027078651254, 45.137377209644193], [-68.63079659587423, 45.144819814875866], [-68.62974497715085, 45.154958790388804], [-68.63132240523592, 45.165002957051868], [-68.628167549065751, 45.172813854358814], [-68.622909455448806, 45.178020520188802], [-68.618702980555256, 45.183970408609639], [-68.622909455448806, 45.200050567962386], [-68.638157926937964, 45.218634647614152], [-68.650777351618629, 45.235447970675416], [-68.651828970342024, 45.241763284543843], [-68.646570876725065, 45.250677818858271], [-68.643416020554909, 45.254391792517787], [-68.632374023959315, 45.260333641829909], [-68.61659974310848, 45.279733134156473], [-68.608712602683056, 45.296064371728683], [-68.586628609491882, 45.321016038116312], [-68.575060803534583, 45.327692675280232], [-68.559286522683749, 45.349293585708878], [-68.544038051194605, 45.357820416256082], [-68.53299605459901, 45.367828523677929], [-68.504602349067497, 45.394600712651815], [-68.485147402684788, 45.411268983182303], [-68.468321503110545, 45.419508688007639], [-68.45885693460005, 45.425803377249153], [-68.447289128642765, 45.432467572294946], [-68.430463229068522, 45.440611623978363], [-68.420472851196337, 45.448384387795713], [-68.410482473324123, 45.461059082579105], [-68.404172760983784, 45.471418746502401], [-68.394182383111584, 45.479187236780419], [-68.390501717579724, 45.485105362967836], [-68.37209838992041, 45.502948423366988], [-68.36526286821838, 45.508864036732184], [-68.362633821409901, 45.515888014860451], [-68.368417724388536, 45.521802259400168], [-68.373675818005481, 45.527069106618917], [-68.37683067417565, 45.531873516750423], [-68.384192005239385, 45.535938464216827], [-68.403646951622093, 45.544436944121344], [-68.430989038430226, 45.555519974737635], [-68.452021412898006, 45.560321938178738], [-68.485147402684788, 45.570386251903088], [-68.498818446088848, 45.574448396460433], [-68.508283014599343, 45.5796179708965], [-68.522479867365107, 45.596600342567456], [-68.526160532896967, 45.601491044583994], [-68.528263770343756, 45.605919989339384], [-68.54035738566273, 45.607396226047555], [-68.549296144811549, 45.612931765424591], [-68.555605857151875, 45.613669795792632], [-68.563492997577299, 45.615145827200166], [-68.567699472470863, 45.62289435053048], [-68.578741469066458, 45.623263300947649], [-68.588731846938657, 45.629166175236641], [-68.597670606087462, 45.628797263923609], [-68.607135174597957, 45.626214816300404], [-68.613444886938311, 45.630641796048721], [-68.617125552470171, 45.638111526334256], [-68.621857836725425, 45.646963242257392], [-68.632899833321019, 45.649544727566202], [-68.641312783108134, 45.645119250861327], [-68.647622495448474, 45.646963242257392], [-68.656561254597278, 45.640693422227507], [-68.656561254597278, 45.640693422227507], [-68.659190301405758, 45.63995574990642]] } },
          { type: 'Feature', properties: { LENGTH: '74.935 km', SINUOSITY: '2.0983262' }, geometry: { type: 'LineString', coordinates: [[-68.659190301405758, 45.63995574990642], [-68.673273803577843, 45.639024221958991], [-68.677610472041039, 45.63192556778327], [-68.687729365121797, 45.626854546356604], [-68.696402702048175, 45.61011689914892], [-68.709412707437735, 45.582209644586897], [-68.722422712827282, 45.562920108258794], [-68.73037327167647, 45.557842806085468], [-68.739769386680052, 45.559366045230519], [-68.74410605514322, 45.563935513272938], [-68.749165501683621, 45.572058088343297], [-68.754947726301197, 45.578656810033891], [-68.762175507073167, 45.584239734158103], [-68.767234953613567, 45.578656810033891], [-68.769403287845151, 45.563427813075052], [-68.772294400153939, 45.562412398824179], [-68.776631068617135, 45.576626517258518], [-68.783136071311915, 45.584239734158103], [-68.79831441093306, 45.586777242211419], [-68.807710525936628, 45.602507215176445], [-68.82433442171218, 45.609609619210985], [-68.832284980561354, 45.613667729407481], [-68.844572207873725, 45.632939716652636], [-68.859027769417679, 45.642573209627116], [-68.862641659803671, 45.651698138885088], [-68.869146662498451, 45.656766897524747], [-68.879265555579209, 45.660821571951416], [-68.882156667887998, 45.667409787562697], [-68.885047780196786, 45.678557297677131], [-68.877819999424815, 45.682610383590998], [-68.864809994035255, 45.682103764013718], [-68.859750547494869, 45.688689458339134], [-68.860473325572059, 45.697806823695792], [-68.864809994035255, 45.703377810460772], [-68.877819999424815, 45.706922692949689], [-68.88577055827399, 45.707429086263616], [-68.903117232126732, 45.715530751302751], [-68.896612229431966, 45.72666861062234], [-68.898057785586346, 45.732236702217719], [-68.904562788281126, 45.744889378025476], [-68.913958903284694, 45.758171581763115], [-68.903117232126732, 45.75867750756688], [-68.898057785586346, 45.763736511657982], [-68.895166673277558, 45.772335758969952], [-68.896612229431966, 45.786496316345129], [-68.89878056366355, 45.797619929193068], [-68.907180132720072, 45.805867361434082], [-68.918525091494033, 45.813609522233399], [-68.933473911369049, 45.816449133272201], [-68.935642245600633, 45.828072020108124], [-68.940965634289967, 45.840766067969355], [-68.941424470218223, 45.847901089092765], [-68.934919467523429, 45.857497319341064], [-68.920981422858929, 45.877555197704488], [-68.886285742329662, 45.906178006538177], [-68.861415387260024, 45.92182315116608], [-68.837159115031596, 45.93467885036597], [-68.81167467712072, 45.943033446716754]] } },
          { type: 'Feature', properties: { LENGTH: '351.79 km', SINUOSITY: '2.5246982' }, geometry: { type: 'LineString', coordinates: [[-68.944750363470888, 45.841610571795897], [-68.957760368860448, 45.844894053913244], [-68.962097037323645, 45.855500893856096], [-68.964265371555229, 45.873174436202902], [-68.965710927709623, 45.878222981023036], [-68.980166489253591, 45.881756687720362], [-68.984503157716759, 45.896898582914964], [-69.005463721955493, 45.90749543752797], [-69.030760954657424, 45.911027270009463], [-69.03582040119781, 45.924647933624215], [-69.04232540389259, 45.930196128110431], [-69.129781551233521, 45.956416395607306], [-69.163029342784611, 45.968513847850232], [-69.204950471262094, 45.981616420878254], [-69.254822158588738, 46.003782897939246], [-69.27939661321345, 46.029968123351999], [-69.283010503599442, 46.04053938828563], [-69.29891162129779, 46.056644068804339], [-69.303971067838177, 46.06519775815012], [-69.306139402069775, 46.081798171298068], [-69.320594963613729, 46.098896370954222], [-69.327822744385713, 46.115989236005667], [-69.329991078617297, 46.138227108051154], [-69.338664415543676, 46.155307696299012], [-69.345169418238456, 46.166356999258895], [-69.343001084006858, 46.177529591027707], [-69.348783308624448, 46.201122613245438], [-69.335773303234888, 46.209653749632444], [-69.332159412848895, 46.242887367025006], [-69.337941637466471, 46.257929891508823], [-69.332882190926085, 46.264071061826897], [-69.307584958224169, 46.273594772762699], [-69.300357177452199, 46.273093566337508], [-69.290961062448631, 46.287626679738821], [-69.27939661321345, 46.301654970093814], [-69.269277720132692, 46.332829907974329], [-69.269277720132692, 46.342341589648925], [-69.281564947445048, 46.362485836403955], [-69.287347172062638, 46.384998507527413], [-69.304169115783836, 46.43296968162494], [-69.346540831828435, 46.482623042012257], [-69.341628169098627, 46.504464566094306], [-69.286904933604802, 46.560038637481341], [-69.30048461873649, 46.573959344554069], [-69.372946394001147, 46.610365953704324], [-69.361892902859083, 46.634482354227828], [-69.363121068541531, 46.656896676666967], [-69.339785920574954, 46.7158481935395], [-69.3293465122741, 46.815010821697911], [-69.352067577399467, 46.881999658279241], [-69.336101423527595, 46.915462551910842], [-69.309695861354882, 46.939231582655999], [-69.286086444757061, 46.948649081785092], [-69.256612133314491, 46.963454627017818], [-69.227584276216817, 46.970409607442555], [-69.181865401287936, 46.977860362422334], [-69.141744204279718, 46.979698633874598], [-69.12353044500999, 46.987335386517394], [-69.116273480735586, 46.990314864616238], [-69.103261679562891, 47.011910094437717], [-69.089422712920225, 47.028474640130376], [-69.069103212951845, 47.06164823084476], [-69.049509409410902, 47.087924332376261], [-69.038168898392939, 47.092306675873395], [-69.019476284422254, 47.09021909998274], [-69.005417813527558, 47.082426897274679], [-68.983447294097033, 47.077859206604188], [-68.960248748835525, 47.075035798407505], [-68.947694026452339, 47.076740528415861], [-68.933365426823727, 47.073664041543836], [-68.915352330147769, 47.068629404793022], [-68.892758981083389, 47.067102833467445], [-68.877552119698976, 47.064992980625078], [-68.868085302550355, 47.068590354897559], [-68.85298880604995, 47.067044327512413], [-68.846314409727086, 47.070573651826969], [-68.851760640367473, 47.08941749743542], [-68.84370933200475, 47.091467898379825], [-68.8449155478542, 47.10545820186983], [-68.851078326099454, 47.120444614321968], [-68.864315222899208, 47.133250803597278], [-68.88028137677108, 47.148334842355098], [-68.884511725232869, 47.171743815418182], [-68.880522190637933, 47.180599983392334], [-68.868682034214601, 47.182909449661025], [-68.849850160416992, 47.190537940992762], [-68.822421126842244, 47.204629142144967], [-68.796424953230357, 47.215508879148679], [-68.769405308216406, 47.217600878817841], [-68.754876659869382, 47.222879153137775], [-68.735282856328425, 47.233198482015432], [-68.717208266712205, 47.238098080862933], [-68.689779233137457, 47.235588647888299], [-68.673198996424361, 47.238098080862933], [-68.646747892180485, 47.24160075341586], [-68.633685356486524, 47.240118097054314], [-68.595619864149498, 47.230848281564185], [-68.561435919321255, 47.222481888423196], [-68.549685995010094, 47.227761003782064], [-68.536623459316132, 47.236658403186297], [-68.492537401349026, 47.245554299608422], [-68.459155365686684, 47.257413156939784], [-68.449721312129938, 47.272232971410965], [-68.438110169290866, 47.279085723772162], [-68.410576234660098, 47.276003845815865], [-68.401281075598163, 47.285505510343199], [-68.393177220825365, 47.291882701363079], [-68.376187595551457, 47.296756826399296], [-68.368624736363273, 47.306241002339824], [-68.360642075661389, 47.318579672916464], [-68.35483650424186, 47.332827230220538], [-68.338871182838133, 47.34910541838763], [-68.322180165006969, 47.357489180887995], [-68.312746111450224, 47.361434017185779], [-68.288072432917176, 47.357489180887995], [-68.271562839192868, 47.350585003266374], [-68.252694732079377, 47.34269340164883], [-68.23818080353054, 47.342200137131613], [-68.228021053546328, 47.331840511056321], [-68.2084272500054, 47.318024495022904], [-68.152730049199207, 47.308153686099459], [-68.138941817077807, 47.298281022072359], [-68.133136245658264, 47.286925164991352], [-68.127330674238721, 47.278036261045798], [-68.097598679915322, 47.266181627272466], [-68.085240281447085, 47.259265862046981], [-68.062743692196378, 47.254819260204485], [-68.051313973464161, 47.249878150826831], [-68.033171562778108, 47.237029095544372], [-68.020834723511598, 47.232086316222954], [-68.011400669954838, 47.214782935415151], [-67.998338134260877, 47.207365461117696], [-67.988904080704131, 47.194011376902274], [-67.980922940082408, 47.181048674679381], [-67.97498680595055, 47.167230367851189], [-67.962500454845625, 47.154665131084037], [-67.960601920033895, 47.142541817642545], [-67.955522045041789, 47.124218428572469], [-67.930158758541054, 47.105422494470183], [-67.842958995087002, 47.081378227631973], [-67.785346232806589, 47.07268082344811], [-67.769380911402862, 47.07268082344811], [-67.748335715007045, 47.065243372938767], [-67.733096090030756, 47.052349318233595], [-67.732370393603318, 47.039948229773309], [-67.745432929297266, 47.031575855082977], [-67.762849643555882, 47.022643865148034], [-67.766478125693098, 47.011228578247142], [-67.759946857846117, 46.99583887137549], [-67.749787107861934, 46.984479896514813], [-67.745432929297266, 46.973056401600374], [-67.753415589999122, 46.952686689158412], [-67.759946857846117, 46.939827396403885], [-67.758495464991228, 46.92441700088078], [-67.754866982854011, 46.894080290399053], [-67.749061411434496, 46.875733120674091], [-67.747610018579593, 46.861299724376003], [-67.741078750732612, 46.836965636638709], [-67.738175965022847, 46.822023617444344], [-67.745432929297266, 46.807077418202852], [-67.756318375708901, 46.809568741697937], [-67.762849643555882, 46.811063480059111], [-67.773009393540079, 46.808073961534895], [-67.781717750669372, 46.802592743296152], [-67.783169143524262, 46.802717322679271]] } },
          { type: 'Feature', properties: { LENGTH: '27.083 km', SINUOSITY: '1.537949' }, geometry: { type: 'LineString', coordinates: [[-67.785625474889173, 46.799343817919969], [-67.785625474889173, 46.799343817919969], [-67.792156742736154, 46.790871224029608], [-67.808122064139894, 46.787880576278802], [-67.816830421269188, 46.78040322532398], [-67.819733206978952, 46.773922009105057], [-67.826990171253371, 46.766941359869776], [-67.835698528382693, 46.760458513208931], [-67.841504099802222, 46.751979759956498], [-67.852389546213857, 46.749984564087292], [-67.863274992625492, 46.74599394937016], [-67.874160439037126, 46.746991630921912], [-67.881417403311545, 46.752478547310396], [-67.89230284972318, 46.756967424455325], [-67.893754242578055, 46.764448050212174], [-67.897382724715271, 46.776414877474963], [-67.901011206852488, 46.786385189697057], [-67.909719563981795, 46.804825369257102], [-67.915525135401325, 46.80980811005054], [-67.930039063950161, 46.814790386379073], [-67.937296028224594, 46.817281350370934], [-67.943827296071561, 46.824255431824682], [-67.946004385353902, 46.827244045207145], [-67.953987046055758, 46.835710875142226], [-67.958341224620412, 46.840690736353416], [-67.962695403185066, 46.84367843015513], [-67.973580849596701, 46.848657548287292], [-67.973580849596701, 46.851644796246397], [-67.981563510298571, 46.856125354707089], [-67.988094778145538, 46.863592116211635], [-67.991723260282754, 46.868071671563932], [-67.994626045992518, 46.866578528241973]] } },
          { type: 'Feature', properties: { LENGTH: '114.26 km', SINUOSITY: '1.7396549' }, geometry: { type: 'LineString', coordinates: [[-67.749358795927748, 46.804040545244305], [-67.75369483208172, 46.794110903727983], [-67.74571217137985, 46.789126699829772], [-67.735552421395667, 46.783145042023918], [-67.732649635685888, 46.774669881809373], [-67.728295457121234, 46.765196055303079], [-67.724666974984032, 46.753725495371732], [-67.718861403564503, 46.745744526078838], [-67.712330135717508, 46.73676451412058], [-67.709427350007758, 46.716304423600434], [-67.71160443929007, 46.69383923707786], [-67.718861403564503, 46.676859300976275], [-67.71305583214496, 46.668866884324707], [-67.696364814313782, 46.656376352046699], [-67.684027975047258, 46.640884058860273], [-67.67894810005518, 46.629386891248359], [-67.684753671474695, 46.615887079631968], [-67.684753671474695, 46.597381835774655], [-67.690559242894253, 46.579871019952414], [-67.69273633217658, 46.571864179469884], [-67.681850885764945, 46.556848146810651], [-67.673142528635637, 46.547335829340057], [-67.668062653643531, 46.538823386245816], [-67.668062653643531, 46.529307889706807], [-67.636132010836093, 46.491229124222805], [-67.633954921553752, 46.477193337532256], [-67.633954921553752, 46.470174077544733], [-67.621618082287242, 46.454690882059744], [-67.612909725157934, 46.443655617921024], [-67.607829850165842, 46.432618103754393], [-67.607104153738405, 46.42458940745194], [-67.604927064456078, 46.416120352263349], [-67.611458332303044, 46.404073193382942], [-67.618715296577477, 46.393027611903953], [-67.629600742989112, 46.37745956401529], [-67.629600742989112, 46.364964229937598], [-67.602749975173751, 46.340341889938394], [-67.584607564487683, 46.321804960665304], [-67.580979082350481, 46.309736850538663], [-67.582430475205356, 46.291629663162034], [-67.585333260915135, 46.281567510450962], [-67.591864528762116, 46.268043563517978], [-67.594767314471881, 46.256970297409431], [-67.595493010899318, 46.248412141000635], [-67.591138832334678, 46.239852640530472], [-67.583881868060246, 46.215740354178592], [-67.580253385923044, 46.209694872637286], [-67.557031100244885, 46.176999889757084], [-67.558482493099774, 46.160865675155435], [-67.572996421648611, 46.147248726656095], [-67.592590225189554, 46.136718483743216], [-67.83787561766502, 46.116030429533858], [-67.853840939068746, 46.117039784331851], [-67.858920814060838, 46.122086279208673], [-67.865452081907819, 46.13419596896464], [-67.879240314029218, 46.148824935888292], [-67.886497278303636, 46.159920163297947], [-67.895931331860396, 46.182103864146406], [-67.899559813997584, 46.199239647116073], [-67.90463968898969, 46.221911092428684], [-67.903913992562252, 46.222918493621471]] } },
          { type: 'Feature', properties: { LENGTH: '98.272 km', SINUOSITY: '1.3708115' }, geometry: { type: 'LineString', coordinates: [[-67.592590225189554, 46.136718483743216], [-67.572701454865282, 46.10708806476007], [-67.563895426615218, 46.093086024734532], [-67.557605406436579, 46.067698205261998], [-67.542509358007891, 46.052810224056664], [-67.529929317650627, 46.0361659341891], [-67.489247278540901, 46.021804181810637], [-67.500995224828955, 45.970415504611488], [-67.523639297472002, 45.957255980564995], [-67.541251353972157, 45.937071933043626], [-67.550057382222235, 45.928293952930836], [-67.595345527508343, 45.905464660178801], [-67.628053632437201, 45.873839263678633], [-67.651955709115981, 45.840437237817483], [-67.732467967402386, 45.837799375669761], [-67.756370044081166, 45.824608176847065], [-67.767692080402711, 45.813173259082909], [-67.760144056188352, 45.800856088859156], [-67.758886052152633, 45.784135544495477], [-67.762660064259805, 45.766529516616544], [-67.770208088474149, 45.755082598255058], [-67.794110165152929, 45.74275250409277], [-67.82933427815324, 45.684587989207536], [-67.836882302367584, 45.677533604410229], [-67.87839643554652, 45.663422148948186], [-67.901040508189581, 45.677533604410229], [-67.926200588904081, 45.683706240068588], [-67.941296637332783, 45.691641478726631], [-67.966456718047297, 45.701338565009003], [-67.992874802797516, 45.70574577196308], [-68.026840911762108, 45.699575584308583], [-68.046968976333716, 45.692523101967666], [-68.055775004583793, 45.686351445519328], [-68.062065024762418, 45.67488797929564], [-68.060807020726685, 45.659893725521059], [-68.073387061083935, 45.641365830349109], [-68.093515125655543, 45.639600947148075], [-68.107353170048512, 45.629893089288124], [-68.11490119426287, 45.614003852380208], [-68.117417202334323, 45.607823480576734], [-68.117417202334323, 45.606057534151063]] } },
          { type: 'Feature', properties: { LENGTH: '24.929 km', SINUOSITY: '1.1199741' }, geometry: { type: 'LineString', coordinates: [[-68.117417202334323, 45.607823480576734], [-68.126223230584387, 45.588394992052933], [-68.136287262870198, 45.568959732178612], [-68.157673331477525, 45.573377431295292], [-68.167737363763322, 45.568076150383199], [-68.2017034727279, 45.561006992352503], [-68.224347545370961, 45.555704536214535], [-68.249507626085474, 45.541562190768673], [-68.277183714871413, 45.540678175254122], [-68.301085791550207, 45.529184700363835], [-68.32876188033616, 45.515920060383067], [-68.362633821409901, 45.515888014860451], [-68.36526286821838, 45.508864036732184]] } }
        ]
      }
    }
  },
  computed: {
    geoOptions () {
      return {
        weight: 2,
        color: '#bd4219',
        dashArray: (8, 7),
        opacity: 1
      }
    },
    terrain () {
      return process.env.VUE_APP_TERRAIN_URL
    },
    greenleaf () {
      // return 'http://dev.digitalgizmo.com/msm-treat/map/tiles/treat/{z}/{x}/{y}.png'
      return process.env.VUE_APP_GREENLEAF_URL
      // return 'tiles/treat/{z}/{x}/{y}.png'
    }
  },
  mounted () {
    // Set offset for future use.
    // console.log('-- TreatMap mounted')
    this.offset = this.$refs.greenMap.mapObject.getSize().x * 0.18
    console.log(' -- initial offset: ' + this.offset)
    console.log(' -- total map width: ' + this.$refs.greenMap.mapObject.getSize().x)
    console.log(' -- total viewport width: ' + window.innerWidth)
    // Determine size for conditional zoom level
    if (window.matchMedia('(max-width: 1800px)').matches) {
      // Viewport less than 1800
      console.log(' -- viewport is less than 1800px')
      this.zoomOffset = -0.25
    } else {
      // Viewport greater than 1800
      console.log(' -- viewport is greater than 1800px')
      this.zoomOffset = 0.5
    }
    // Recenter map initially.
    this.$refs.greenMap.mapObject.panBy(new L.Point(-this.offset, 0), { animate: false })
    // Listen for resetting center
    eventBus.$on('reSetView', (index) => {
      // console.log('-- TreatMap.vue reSetView (data ready)')
      // Set Marker highlight
      // Avoid trying to set marker for intro 0
      if (index > 0) {
        this.goMarker(index)
      } else {
        // Returning to intro
        if (this.prevSelected > 0) {
          // But only reset if a marker has been selected
          this.markerList[this.prevSelected - 1].setIcon(this.defaultIcon(this.prevSelected))
        }
      }
      // Using native setView as Vue2Leaflet encounters a
      // bug in Leaflet -- can't animate both pan and zoom
      // Also using custom offset. Uses prototype in main.js.
      // Per VueLeaflet doc on API, need to wait until data registers
      // console.log('-- reSetView (dataReady) nextTick set position for index: ' + index)
      // console.log('- index: ' + index)
      // console.log('- entry.zoom_level: ' + this.entry.zoom_level + ', zoomOffset: ' + this.zoomOffset)
      // console.log(' - setting zoom to: ' + (this.entry.zoom_level + this.zoomOffset))
      this.$nextTick(() => {
        this.$refs.greenMap.mapObject.setViewOffset(L.latLng(this.entry.lat,
          this.entry.lon), [this.offset, 0], this.entry.zoom_level + this.zoomOffset)
      })
    }) // end eventBus on reSetView
    // Set zoom to Admin entry
    // this.zoom = this.entries[0].zoom_level

    // L.marker([46.49, -68.43], { icon: this.treatIcon }).addTo(this.$refs.greenMap.mapObject)
    this.markerList = []
    eventBus.$on('dataReady', () => {
      // Set map view and content to intro, 0
      // (otherwise we seem to start with hard-wired data above)
      // console.log(' in dataReady reSetEntry')
      this.reSetEntry(0)
      // Create markers "by hand" with $ref -- vue2leaflet doesn't allow
      // enough custom handling of the icons
      // Need to wait until data is ready to creat markers
      // BTW, don't need $nextTick since we're already waiting for dataReady
      this.entries.forEach((jrnEntry, index) => {
        // console.log('-- lat, index: ' + jrnEntry.lat + ', ' + index)
        // L.marker([jrnEntry.lat, jrnEntry.lon], { icon: this.treatIcon })
        if (index > 0) {
          this.markerList.push(L.marker([jrnEntry.lat, jrnEntry.lon], {
            icon: this.defaultIcon(index)
          })
            .addTo(this.$refs.greenMap.mapObject)
            .on('click', e => {
              this.reSetEntry(index)
            }) // end on click
          ) // end push
        } // end if > 0
      }) // end forEach
    }) // end eventBus on
  },
  methods: {
    defaultIcon (index) {
      return new L.DivIcon({
        className: 'icon-div',
        html: '<img class="icon-image" src="images/markers/treat-marker-icon-2x.png"/>' +
        '<div class="inner-div">' +
        '<span class="icon-number">' + index + '</span>' +
        '</div>',
        iconAnchor: [8, 46]
      })
    },
    selectedIcon (index) {
      return new L.DivIcon({
        className: 'icon-div',
        html: '<img class="icon-image" src="images/markers/hilite-treat-marker-icon-2x.png"/>' +
          '<div class="inner-div">' +
          '<span class="icon-number-selected">' + index + '</span>' +
          '</div>',
        iconAnchor: [8, 46]
      })
    },
    customZoom (increment) {
      // console.log(" - current zoom: " + this.$refs["greenMap"].mapObject.getZoom());
      // console.log(' - current lat: ' + this.$refs.greenMap.mapObject.getCenter().lat)

      // Thought I needed to use setViewOffset rather than just setZoom, but that
      // only worked when it was based on the chosen site. With any random location it
      // was too hard to figure the offset.
      this.$refs.greenMap.mapObject.setZoom(this.$refs.greenMap.mapObject.getZoom() + increment)
    },
    latAndLng (pLat, pLng) {
      // return L.latLng(this.entry.lat -0.5, this.entry.lon - 0.5)
      return L.latLng(pLat, pLng)
    },
    goMarker (index) {
      // console.log('-- reseting item: ' + item.title + ', index: ' + index)
      // Index is - 1 because we omitted 0 from the marker list
      this.markerList[index - 1].setIcon(this.selectedIcon(index))
      // Reset previously selected to default (if there's been a previous selectiom)
      if (this.prevSelected > 0) {
        this.markerList[this.prevSelected - 1].setIcon(this.defaultIcon(this.prevSelected))
      }
      this.prevSelected = index
      // this.reSetEntry(index)
    },
    innerClick () {
      alert('Click!')
    }
  }
}
</script>

<style lang="scss">

  .inner-div {
    position: absolute;
    background: transparent;
    /*border-style: solid;
    border-width: thick;*/
    top: 3px;
    left: -1px;
    width: 25px;
    height: 40px;
    text-align: center;
  }
  .icon-image{
    position: absolute;
    width: 25px;
  }

 /* .icon-number{
    position: absolute;
    left: 8px;
    top: 3px;
  }
*/
  .icon-number-selected{
    color: #C64C17;
  }

  .map-wrapper {
    grid-row: 1;
    grid-column: 1 / 3;
  }

  #mapdiv {
    display: block;
    height: 100%;
    position: relative;
    z-index: 1;
  }

  .map-layers-controls {
    background-color: rgba(53, 53, 36, 0.8);
    border: 1px solid #b3aa98;
    font-size: .85em;
    padding: 1em 1.5em;
    position: absolute;
    right: 2%;
    top: 2%;
    z-index: 17;

    div.layers {
      margin-bottom: 1.5em;
    }

    div.layers p {
      margin-bottom: .25em;
      padding: 0;
      white-space: nowrap;
    }

    h3 {
      font-size: 1.25em;
      font-variant: small-caps;
      letter-spacing: .05em;
      margin-bottom: 0.15em;
    }

    img {
      max-height: 36px;
      margin-right: .75em;
    }
  }

  /*just a hack*/
  input {
    float:left;
  }

  /* Needed to keep the pointer over markers -- otherwise reverts to grab on change*/
  .leaflet-overlay-pane path,
  .leaflet-marker-icon {
    cursor: pointer;
  }

  input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  input[type="checkbox"], input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  /*for medium displays, less than or equal to 1800px and greater than 1200px*/
  @media screen and (max-width: 1800px) {
    .map-layers-controls {
      font-size: .75em;
      padding: 0.75em 1em;
    }
  }

  /*for small displays, less than or equal to 1200px and greater than 800px*/
  @media screen and (max-width: 1200px) {
    .map-layers-controls {
      font-size: 0.5em;
      padding: 0.5em;

      img {
        max-height: 24px;
      }
    }
  }

</style>
